import CONST from './constants';

const initialState = {
  loading: false,
  new: [],
  updates: [],
  errors: [],
  data: [],
  imported: 0,
  result: [],
  users_not_found: [],
  job_id: null,
  job_status: null,
  meta: { total_count: 0 },
};

export const arrayToObj = (arr) => {
  return arr.reduce((obj, item) => {
    obj[item.id] = item;
    return obj;
  }, {});
};

const index = (state = initialState, { type, payload, error, meta }) => {
  switch (type) {
    case CONST.JPAS_UPDATE_USERS_PENDING:
      return {
        ...state,
        loading: true,
      };
    case CONST.JPAS_UPDATE_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        imported: payload.data,
      };
    case CONST.JPAS_GET_USERS_PENDING:
      return {
        ...state,
        loading: true,
      };
    case CONST.JPAS_GET_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: arrayToObj(payload.data),
        meta: { ...payload.meta },
        result: payload.data.map((d) => d.id),
      };
    case CONST.JPAS_REFRESH_PENDING:
      return {
        ...state,
        loading: true,
      };
    case CONST.JPAS_REFRESH_SUCCESS:
      return {
        ...initialState,
      };
    case CONST.JPAS_UPLOAD_PENDING:
      return {
        ...state,
        loading: true,
      };
    case CONST.JPAS_UPLOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        job_id: payload?.job_id,
        job_status: payload?.status || 'pending',
      };
    case CONST.JPAS_CURRENT_JOB_PENDING:
      return {
        ...state,
        loading: true,
      };
    case CONST.JPAS_CURRENT_JOB_SUCCESS:
      return {
        ...state,
        loading: false,
        job_id: payload?.id,
        job_status: payload?.status,
      };
    case CONST.JPAS_JOB_STATUS_PENDING:
      return {
        ...state,
        loading: true,
      };
    case CONST.JPAS_JOB_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        job_id: payload?.id,
        job_status: payload?.status,
        total_records: payload?.total_records || 0,
        processed_records: payload?.processed_records || 0,
        successful_records: payload?.successful_records || 0,
        failed_records: payload?.failed_records || 0,
        progress_percentage: payload?.progress_percentage || 0,
        success_rate: payload?.success_rate || 0,
        error_message: payload?.error_message || null,
        users_not_found: payload?.users_not_found || [],
      };
    default:
      return state;
  }
};

export default index;
